module.exports = __webpack_public_path__ + "static/prs-logo-black-911a27d6873e809a885fb64d7ec94646.png";